document.addEventListener('DOMContentLoaded', function() {
  // Get elements
  var isGiftCheckbox = document.getElementById('isGift');
  var modal = document.getElementById('giftMessageModal');
  var closeModal = document.querySelector('.close');
  var messageTextarea = document.getElementById('custom-message');
  var messagePreview = document.getElementById('message-preview-text');
  var cartNoteInput = document.getElementById('cart-note-input'); // Add this line

  // Function to show or hide the modal
  function toggleModal(show) {
    modal.style.display = show ? 'block' : 'none';
  }

  // Function to handle form submission
  function handleFormSubmit(event) {
    event.preventDefault();
    var to = document.getElementById('to').value;
    var from = document.getElementById('from').value;
    var message = messageTextarea.value;
    
    // Append the gift message to the existing cart note
    var currentNote = cartNoteInput.value || '';
    var orderNote = currentNote + '\nGift Message To: ' + to + '\nMessage: ' + message + '\nFrom: ' + from;
    
    // Update the cart note field
    cartNoteInput.value = orderNote;

    // Close the modal
    toggleModal(false);
  }

  // Function to update the message preview in real-time
  function updateMessagePreview() {
    var message = messageTextarea.value;
    messagePreview.textContent = message;
  }

  // Set the initial state of the message preview
  messagePreview.textContent = "Start typing your message...";

  // Event listeners
  isGiftCheckbox.addEventListener('change', function() {
    toggleModal(this.checked);
  });

  closeModal.addEventListener('click', function() {
    toggleModal(false);
  });

  messageTextarea.addEventListener('input', updateMessagePreview);
});
